module.exports = __webpack_public_path__ + "static/media/4.699d9490.jpg";